import { FC } from 'react';
import { useParams } from 'react-router';
import { AssessmentStatus } from 'api/hooks/assessment/assessmentTypes';
import { useCheckAssessmentStatus } from 'api/hooks/common/useCheckAssessmentStatus';
import { SDGAssessmentListTable } from './sdg-assessment-list-table';

export const SDGAssessment: FC = () => {
    const { assessmentId } = useParams();

    const assessmentStatus = useCheckAssessmentStatus({
        assessmentId: assessmentId ?? '',
        currentStatuses: [
            AssessmentStatus.ANALYSIS_IN_PROGRESS,
            AssessmentStatus.ASSURANCE_IN_PROGRESS,
        ],
    });

    return <SDGAssessmentListTable isReadonly={assessmentStatus.isReadOnly} />;
};
